import type { CompanyIntegrationsData } from '../../../types/company-integrations/CompanyIntegrationsData';
import { v3ApiClient } from '../clients/v3ApiClient';

const getCompanyIntegrationsStatus = async (): Promise<CompanyIntegrationsData> => {
  const response = await v3ApiClient.get('companyintegrations/status');

  return response.data;
};

const IntegrationsService = {
  getCompanyIntegrationsStatus,
};

export default IntegrationsService;
